import {API_REACTIVE_URL} from './apiReactiveConfig';
import {API_BLOCKING_URL} from './apiBlockingConfig';

export const API_REACTIVE = API_REACTIVE_URL;
export const API_BLOCKING = API_BLOCKING_URL;